import type React from "react"
import styled from "styled-components"
import { overloadColor } from "~/utils/style"
import {
  Book,
  Books,
  Check,
  ChevronDown,
  ChevronUp,
  Circle,
  CircleDot,
  Cog,
  Coins,
  Document,
  Download,
  Ellipsis,
  Exit,
  Globe,
  Home,
  Layout_1,
  Layout_1_1_1_1,
  Layout_1_2,
  Layout_2_1,
  Layout_2_2,
  Layout_one,
  Magnifier,
  MathIcon,
  Print,
  ShareNodes,
  Star,
  Trash,
  User,
} from "./icons"

interface WrapperProps {
  hoverColor?: string
}
const Wrapper = styled.span<WrapperProps>`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  svg {
    &:hover {
      fill: ${(props) => props.hoverColor && overloadColor(props.hoverColor)};
    }
  }
`

export enum ArbeidsarkIcon {
  Book = "Book",
  Books = "Books",
  Check = "Check",
  ChevronDown = "ChevronDown",
  ChevronUp = "ChevronUp",
  Circle = "Circle",
  CircleDot = "CircleDot",
  Cog = "Cog",
  Coins = "Coins",
  Document = "Document",
  Download = "Download",
  Ellipsis = "Ellipsis",
  Exit = "Exit",
  Globe = "Globe",
  Home = "Home",
  Magnifier = "Magnifier",
  Math = "Math",
  Print = "Print",
  Star = "Star",
  ShareNodes = "ShareNodes",
  User = "User",
  Trash = "Trash",
  Layout_one = "Layout_one",
  Layout_1x1 = "Layout_1x1",
  Layout_1x2 = "Layout_1x2",
  Layout_2x1 = "Layout_2x1",
  Layout_2x2 = "Layout_2x2",
  Layout_1x1x1x1 = "Layout_1x1x1x1",
}

export type ArbeidsarkIconKeys = keyof typeof ArbeidsarkIcon

export const arbeidsarkIcons: {
  [key in ArbeidsarkIcon]: React.FC<React.SVGAttributes<SVGSVGElement>>
} = {
  Book,
  Books,
  Check,
  ChevronDown,
  ChevronUp,
  Circle,
  CircleDot,
  Cog,
  Coins,
  Document,
  Download,
  Ellipsis,
  Exit,
  Globe,
  Home,
  Magnifier,
  Math: MathIcon,
  Print,
  Star,
  ShareNodes,
  User,
  Trash,
  Layout_one,
  Layout_1x1: Layout_1,
  Layout_1x2: Layout_1_2,
  Layout_2x1: Layout_2_1,
  Layout_2x2: Layout_2_2,
  Layout_1x1x1x1: Layout_1_1_1_1,
}

export interface SVGIconProps extends React.SVGAttributes<SVGSVGElement> {
  className?: string
  icon: ArbeidsarkIconKeys

  hoverColor?: string
}

export const SVGIcon: React.CFC<SVGIconProps> = ({
  className,
  icon,
  hoverColor,
  ...svgProps
}) => {
  svgProps = {
    ...svgProps,
    fill:
      typeof svgProps.fill !== "undefined"
        ? overloadColor(svgProps.fill)
        : undefined,
  }

  const SVG = arbeidsarkIcons[icon]

  return (
    <Wrapper className={className} hoverColor={hoverColor}>
      <SVG {...svgProps} />
    </Wrapper>
  )
}
